import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { SecurityService } from '../core/services/security.service';

@Component({
	selector: 'home',
	templateUrl: './home.page.html',
	styleUrls: ['./home.page.scss']
})
export class HomePage implements OnInit {

	todayIs: string;
	currentMonth: string;

	constructor(
		private appService: AppService,
		private securityService: SecurityService) {
		this.appService.pageTitle = '';
	}

	ngOnInit(): void {
		// this.dashboardService.getDashboard().subscribe(x => {
		// 	this.dashboardData = x.data;
		// 	this.dashboardData.dailySales.forEach(x => x.dailySales.forEach(y => y.date = this.intl.parseDate(y.date + '')));
		// });

		this.securityService.check().subscribe();
	}
}